<template>
	<div>
		<v-row justify="center">
			<v-col cols="12" md="12" class="text-right py-0">
				<v-btn text small  @click="gotoEditWholesaler"> 
					<img src="@/assets/edit.svg" alt="img" class="mr-1">
					<span class="secodry-text-2">{{$lang.EDIT}}</span>
				</v-btn>
			</v-col>
		</v-row>
		<v-row justify="center">
			<v-col cols="12" md="6">
				<div>
					<label class="fs-16  page-title ">{{$lang.FIRM_NAME}}</label>
					<p class="secondary-text"> {{wholesaler_details.firm_name}}</p>
				</div>
				<div class="pt-5"> 
					<label class="fs-16  page-title ">{{$lang.MOBILE_NO}}</label>
					<p class="secondary-text"> {{wholesaler_details.mobile}}</p>
				</div>
				<div class="pt-5"> 
					<label class="fs-16  page-title ">{{$lang.LANDLINE_NO}}</label>
					<p class="secondary-text"> {{wholesaler_details.landline_number}}</p>
				</div>
				<div class="pt-5"> 
					<label class="fs-16  page-title ">{{$lang.EMAIL_ID}}</label>
					<p class="secondary-text"> {{wholesaler_details.email}}</p>
				</div>
				<div class="pt-5"> 
					<label class="fs-16  page-title ">{{$lang.SHOP_NO}}</label>
					<p class="secondary-text"> {{wholesaler_details.shop_number}}</p>
				</div>
				<div class="pt-5"> 
					<label class="fs-16  page-title ">{{$lang.FULL_ADDRESS}}</label>
					<p class="secondary-text"> {{wholesaler_details.full_address}}</p>
				</div>
				<div class="pt-5"> 
					<label class="fs-16  page-title ">{{$lang.PIN_CODE}}</label>
					<p class="secondary-text"> {{wholesaler_details.pincode}}</p>
				</div>
				<div class="pt-5"> 
					<label class="fs-16  page-title ">{{$lang.CITY}} {{$lang.STATE}}</label>
					<p class="secondary-text"> {{wholesaler_details.city}} {{wholesaler_details.state}}</p>
				</div>
			</v-col>
			<v-col cols="12" md="6">
				<div>
					<label class="fs-16  page-title ">{{$lang.GST_NUMBER}}</label>
					<p class="secondary-text"> {{wholesaler_details.gst_number}}</p>
				</div>
				<div class="pt-5">
					<label class="fs-16  page-title ">{{$lang.DAYS_REMAINING}}</label>
					<p class="secondary-text"> {{wholesaler_details.days_remaining}}</p>
				</div>
				<div class="pt-5">
					<label class="fs-16  page-title ">{{$lang.SHIPMENT_REMAINING}}</label>
					<p class="secondary-text"> {{wholesaler_details.shipment_remaining}}</p>
				</div>


				<div  class="pt-5" v-if="$store.state.user_type!=$keys.WHOLESALER">
					<label class="fs-16  page-title">{{$lang.ACCESS}} </label> <br>
					<div class="d-flex flex-row pt-0 m-t-negative-10"  >
						<div class="pt-4">
							<span class="secondary-text" v-if="wholesaler_details.is_active">{{$lang.ENABLED}} </span>
							<span class="secondary-text" v-if="!wholesaler_details.is_active">{{$lang.DISABLED}} </span>
						</div>
						<div class="pl-3">
							<v-switch color="primary"
							v-model="wholesaler_details.is_active"
							:ripple="false" 
							class="custome-toggle-btn" 
							:class="wholesaler_details.is_active?'active-toggle-btn':'deactive-toggle-btn'" inset 
							@click="ChangeWholesalerVerificationStatus"></v-switch>
						</div>
					</div>
				</div>
			</v-col>
		</v-row>
	</div>
</template>
<script type="text/javascript">
export default {
	data () {
		return {
			wholesaler_id:"",
			edit_img:"",
			wholesaler_details:{
				firm_name:"",
				email:"",
				full_address:"",
				landline_number:"",
				mobile:"",
				pincode:"",
				shop_number:"",
				wholesaler_id:"",
				gst_number:"",
				city:"",
				state:"",
				is_active:false,
				shipment_remaining:"",
				days_remaining:"",

			}
		}
	},
	created(){
		if (this.$route.params.wholesaler_id){
			this.wholesaler_id= this.decrypt(this.$route.params.wholesaler_id)
		}
		this.getWholeSalerDetails()
	},
	methods:{
		/* Fetvhing wholesaler Detailf from API*/ 
		getWholeSalerDetails(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={
				wholesaler_id:self.wholesaler_id
			};

			const successHandler = (response) => {
				console.log(response)
				self.wholesaler_details=response.data.data
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)
				
			};
			self.request_GET( self,self.$urls.WHOLESALER_PROFILE,params,successHandler,null,null,finallyHandler)

		},
		gotoEditWholesaler(){
			if(this.$store.state.user_type==this.$keys.WHOLESALER)
				this.$router.push({name:'wholesaler-edit-profile'})
			else
				this.$router.push({name:'edit-wholesaler',params:{wholesaler_id:this.encript(this.wholesaler_id)}})

		},
		ChangeWholesalerVerificationStatus(){
			const self=this;
			self.btn_loding=true
			var	form = new FormData();
			let  is_active="False"
			if(self.wholesaler_details.is_active)
				is_active="True"

			form.append("wholesaler_id",self.wholesaler_details.wholesaler_id);
			form.append("is_active",is_active);

			const successHandler = (response) => {
				if (response.data.success){
					this.getWholeSalerDetails()
				}
			};
			const finallyHandler = () => {
				self.btn_loding=false
			};
			
			this.request_POST(self,this.$urls.WHOLESALER_CHANGE_VERIFIACATION_STATUS,form,successHandler,null,null,finallyHandler)
		},
	}
}


</script>